import React from 'react';
import aboutImage from '../../assets/images/shapes/about-one-shape-1.png';
import aboutImg1 from '../../assets/images/resources/about-one-img-1.jpg';
import aboutImg2 from '../../assets/images/resources/about-one-img-2.jpg';

const AboutOne = ({
    className = "about-one about-two pt-2",
    tagline = "About Us",
    title = "Seamless logistics for your business needs",
    description = "Construction is an essential industry that involves building and designing structures such as buildings, roads, and bridges",
    listItems = [
        {
            iconClass: "icon-conveyor-1",
            title: "Delivering success through logistics",
        },
        {
            iconClass: "icon-clock",
            title: "Logistics expertise for your competitive edge",
        },
        {
            iconClass: "icon-fragile",
            title: "Streamlining supply chain processes",
        },
    ],
    images = {
        shapeImage: aboutImage,
        photo1: aboutImg1,
        photo2: aboutImg2,
    },
    trustedCount = 6,
    trustedText = "Trusted Customer",
    linkTo = "/about",
    buttonText = "Read more",
    containerClass = "container",
    imgAltTexts = {
        photo1: "Construction site",
        photo2: "Construction equipment",
    },
}) => {
    return (
        <section className={'pt-5'}>
            <div className={containerClass}>
                <div className="row">
                    <div className="col-xl-4">
                        <div className="about-one__left">
                            <div className="section-title text-left">
                                <div className="section-title__tagline-box">
                                </div>
                                <h1 style={{fontWeight: '700', color: '#006FB4',fontFamily: 'Montserrat'}} className="text-bold">
                                    About <br /> Company
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8 pt-5"> 
                        <h5 style={{fontWeight: '500', color: 'black', fontSize: '42px',fontFamily: 'Montserrat'}} className='mb-3'>
                            We are a leading logistics company specializing in efficient transportation, warehousing, and supply chain solutions.
                        </h5>
                        <p style={{fontSize: '18px', fontFamily: 'Montserrat'}}>
                        From freight management to last-mile delivery, we ensure seamless movement of goods with speed and reliability. Our expertise in drayage and intermodal logistics helps businesses optimize operations and reduce costs.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutOne;
